export default "__VITE_ASSET__DjHaKTow__"